<template>
  <div
    class="check-table-header"
    :style="{
      '--division': division
    }"
  >
    <div v-for="i in division" :key="`check_table_header_${i}`" class="header-type-fire-fighting">
      <div class="item A"><span>{{ title }}</span></div>
      <div class="item B"><span>점검 주기</span></div>
      <div class="item C"><span>점검결과(직전)</span></div>
      <div class="item D"><span>점검결과(당월)</span></div>

      <div class="item C1"><span>A</span></div>
      <div class="item C2"><span>B</span></div>
      <div class="item C3"><span>C</span></div>
      <div class="item C4"><span>제외</span></div>
      <div class="item C5"><span>없음</span></div>

      <div class="item D1"><span>A</span></div>
      <div class="item D2"><span>B</span></div>
      <div class="item D3"><span>C</span></div>
      <div class="item D4"><span>제외</span></div>
      <div class="item D5"><span>없음</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckTableHeader',
  props: {
    title: String,
    division: { type: Number, default: () => { return 1 }},
  },

}
</script>

<style lang="scss" scoped>
.check-table-header {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(var(--division), 1fr);
}
.item {
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 50px;

  border-bottom: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}
.header-type-fire-fighting {
  display: grid;
  grid-template-columns: 1fr 43px repeat(10, 50px);
  grid-template-areas:
    "A  B  C  C  C  C  C  D  D  D  D  D "
    "A  B  C1 C2 C3 C4 C5 D1 D2 D3 D4 D5";

  .A { height: 100%; grid-area: A; }
  .B { height: 100%; grid-area: B; text-align: center;}
  .C { height: 100%; grid-area: C; }
  .C1 { height: 100%; grid-area: C1; }
  .C2 { height: 100%; grid-area: C2; }
  .C3 { height: 100%; grid-area: C3; }
  .C4 { height: 100%; grid-area: C4; }
  .C5 { height: 100%; grid-area: C5; }
  .D { height: 100%; grid-area: D; }
  .D1 { height: 100%; grid-area: D1; }
  .D2 { height: 100%; grid-area: D2; }
  .D3 { height: 100%; grid-area: D3; }
  .D4 { height: 100%; grid-area: D4; }
  .D5 { height: 100%; grid-area: D5; }
}
</style>
